export const vert = /*glsl*/ `
precision mediump float;

uniform mat4 projectionMatrix;
uniform mat4 modelViewMatrix;
uniform mat4 normalMatrix;

attribute vec3 position;
attribute vec3 normal;
attribute vec2 uv;

varying vec3 vNormal;
varying vec2 vUv;

uniform float curveIntensity;

void main(){
  vUv = uv;
  mat4 projectionModelViewMatrix = projectionMatrix * modelViewMatrix;
  vNormal = (projectionModelViewMatrix * vec4(normal, 1.)).xyz;

  gl_Position = projectionModelViewMatrix * vec4(position, 1.);
}`;
